
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

interface NavTab {
  route: string;
  icon: string;
  labelKey: string;
  label?: string;
}

@Component({ name: 'SPNav' })
export default class SPNav extends Vue {
  @Prop()
  protected spId!: number;

  private allTabs: NavTab[] = [
    { route: 'serviceProvider',              icon: 'mdi-cube-send',      labelKey: 'services.provider.nav.details' },
    { route: 'serviceProvidersServices',      icon: 'mdi-room-service',   labelKey: 'services.provider.nav.services' },
    { route: 'serviceProviderProducts',       icon: 'mdi-package-variant', labelKey: 'services.provider.nav.products' },
    { route: 'serviceProvidersPromotions',    icon: 'mdi-ticket-percent', labelKey: 'services.provider.nav.promotions' },
    { route: 'serviceProvidersLockers',       icon: 'mdi-share-variant',  labelKey: 'services.provider.nav.lockers' },
  ];

  get visibleTabs(): NavTab[] {
    return this.allTabs.map(tab => ({
      ...tab,
      label: this.$t(tab.labelKey) as string,
    }));
  }

  get activeTabIndex(): number {
    const currentRoute = this.$route.name;
    return this.visibleTabs.findIndex(tab => tab.route === currentRoute);
  }

  tabRoute(tab: NavTab): any {
    return { name: tab.route, params: { spId: String(this.spId) } };
  }

  isActive(routeName: string): boolean {
    return this.$route.name === routeName;
  }
}
